import { useEffect, useState } from "react";
import { Sidebar } from "../../components/Sidebar";
import { Header } from "../../components/Header";
import { Load } from "../../components/Load";
import { Main } from "../../components/Main";
import { CardContent } from "../../components/CardContent";
import { Title } from "../../components/Title";
import { Alert, Col, Row } from "react-bootstrap";
import { TBody, TCell, TGroup, THeader, TRow, Table } from "../../components/Table/Table";
import api from "../../services/api";
import './style.css';

const AsosAssinados = () => {
    const [items, setItems] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            const { data: user } = await api.get('dados-usuario');
            const response = await api.get(`listas-asos/${user.id}`);
            if (response.status === 200) {
                const sortedItems = response.data.sort((a: any, b: any) => new Date(b.docs_assinados.created_at).getTime() - new Date(a.docs_assinados.created_at).getTime());
                setItems(sortedItems);
                setIsLoading(false);
            } else {
                setItems([]);
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} às ${(date.getHours()).toString().padStart(2, '0')}h${date.getMinutes().toString().padStart(2, '0')}`;
        return formattedDate;
    };

    return (
        <>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route="./" />
            <Main>
                <Title text="Meus Documentos" />
                <CardContent>
                    <Title text="ASOS" />
                    {items.length > 0 ? (
                        <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                            <div style={{ overflow: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Cód</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Consulta</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Funcionário</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Empresa</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Clínica</th>
                                            <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '14px', fontWeight: 'normal' }}>Data</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item: any, index: any) => (
                                            <tr key={index} style={{ textAlign: 'center' }}>
                                                <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                    {item.docs_assinados.id}
                                                </td>
                                                <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                    {item.consulta.id}
                                                </td>
                                                <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                    {item.func.nome}
                                                </td>
                                                <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                    {item.empresa.nome}
                                                </td>
                                                <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                    {item.docs_assinados.cliente}
                                                </td>
                                                <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '12px' }}>
                                                    {formatDate(item.docs_assinados.created_at)}
                                                </td>
                                            </tr>
                                        ))}
                                        {items.length === 0 && (
                                            <tr>
                                                <td colSpan={3} style={{ padding: '15px', textAlign: 'center', fontSize: '12px' }}>
                                                    Nenhum dado disponível
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : (
                        <Col className="d-flex justify-content-center" style={{ marginTop: '20px' }}>
                            <Row>
                                <Alert variant="danger" className="text-center">Nenhum documento ASO encontrado!</Alert>
                            </Row>
                        </Col>
                    )}
                </CardContent>
            </Main>
        </>
    );
}

export default AsosAssinados;